import React from "react";
import styles from "./AboutMe.module.css";
import ico from "../Assets/developemnt.png";

const AboutMe = () => {
  return (
    <div className={styles.Main}>
      <div className={styles.w70}>
        <div className={styles.Heading}>Hey, I'm Hrusikesh!</div>
        <div className={styles.SubHeading}>Welcome to my blog post. 😊</div>

        <div className={styles.Content}>
          Hey, I'm a software developer from Delhi, India. I have a great
          experience in mobile app development. I started my career as a Native
          android app developer, and currently, I'm working as a hybrid mobile
          app developer using React native.
        </div>

        <div className={styles.Content}>
          More{" "}
          <a href="/me/me" style={{ fontWeight: "bold" }}>
            About Me
          </a>
        </div>
      </div>
      <div className={styles.w30 + " " + styles.EmptySpace}>
        <img
          src={ico}
          alt="software_development"
          style={{ height: 400, width: "100%" }}
        />
      </div>
    </div>
  );
};

export default AboutMe;
